import gql from 'graphql-tag';

export const START_DEAL_BUILDER = gql`
  mutation StartDealBuilder($input: StartDealBuilderInput!) {
    dealBuilder {
      startDealBuilder(input: $input) {
        success
        error
        entity {
          proposalId
          proposalContacts {
            proposalContactsId
            proposalId
            ownerPgId
            accountContactId
          }
          proposalEquipments {
            proposalEquipmentsId
            proposalId
            equipmentId
          }
        }
      }
    }
  }
`;
